import React, { useEffect } from 'react';
import './Grid.css';

function GridAnimation() {
  useEffect(() => {
    // Add grid items dynamically using JavaScript
    const container = document.querySelector('.grid-container');
    const numItems = 900;
    for (let i = 0; i < numItems; i++) {
      const gridItem = document.createElement('div');
      gridItem.classList.add('grid-item');
      container.appendChild(gridItem);
    }
  }, []);

  return (
    <div className="grid-container">
      {/* Grid items will be added dynamically using JavaScript */}
    </div>
  );
}

export default GridAnimation;
